const base = {
  office:  "http://office.58jl.net:9980/loleaflet/2fc9aba/loleaflet.html?WOPISrc=http%3A%2F%2Foffice.58jl.net%2Fwopi%2Ffiles%2F",
  web_lab: process.env.NODE_ENV === "development" ? "web_lab" : "https://wlab.58jl.net/wlab_php",
  jl_online: process.env.NODE_ENV === "development" ? 2 : 0
};
export default base;
